export default __webpack_public_path__ + "static/media/upload.086d5f35.svg";